import React from "react";

/* Bare check mark — selection ticks in menus and lists.
 *
 * `stroke` is a prop rather than currentColor because the tick is an accent
 * against the row's own text colour; the default is the selection coral. */
export const CheckIcon = ({ size = 14, stroke = "var(--coral)", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M3.5 8.5l3 3 6-7"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckIcon;
